// The current environment's tier as data-env on <body>: it colours the top bar and, in
// production, shows the read-only banner. The environment switch (1e) sets it.
import { useSyncExternalStore } from "react";
import { type EnvTier, envTiers } from "../../ui/env-badge";
import { watchAttribute } from "./theme";

export function setEnvTier(tier: EnvTier | null): void {
  if (tier) document.body.dataset.env = tier;
  else delete document.body.dataset.env;
}

export function currentEnvTier(): EnvTier | null {
  const value = document.body.dataset.env;
  return envTiers.find((tier) => tier === value) ?? null;
}

const subscribe = watchAttribute(() => document.body, "data-env");

/** The current tier, re-rendering when it changes. */
export const useEnvTier = (): EnvTier | null => useSyncExternalStore(subscribe, currentEnvTier);
